import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Popover, Progress, Space, Table } from "antd";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
const RankTableFaculty = ({ data }) => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const navigate = useNavigate();

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) => searchedColumn === text,
  });
  const content = (item) => {
    return (
      <div>
        <img
          style={{ height: "40px" }}
          src={
            item.institution?.photo_url
              ? item.institution.photo_url
              : "https://scholar.google.com/citations/images/avatar_scholar_256.png"
          }
          alt="institution"
        />
      </div>
    );
  };
  const columnsFaculty = [
    {
      title: "Faculty member",
      dataIndex: "photo",
      ...getColumnSearchProps("name"),
      render: (_, record, index) => {
        return (
          <div
            key={index}
            className="record-name"
            onClick={() =>
              navigate(`/benchmarking/faculty/profile/${record.id}`)
            }
          >
            <img
              src={
                record?.photo_url !== null
                  ? record?.photo_url
                  : "https://scholar.google.com/citations/images/avatar_scholar_256.png"
              }
              alt="avatar"
            />
            <p style={{ cursor: "pointer" }}>{record?.name}</p>
          </div>
        );
      },
    },
    {
      title: "Institution",
      dataIndex: "photo",
      render: (_, record, index) => {
        return (
          <div className="institution-info">
            <Popover content={content(record)} key={index}>
              <p className="institution">{record?.institution?.name}</p>
            </Popover>
            <p className="position">{record?.position}</p>
          </div>
        );
      },
    },
    // {
    //   title: "Seniority level",
    //   sorter: (a, b) => a.seniority - b.seniority,
    //   render: (_, record, index) => {
    //     return (
    //       <div className="seniority-level" key={index}>
    //         <Progress
    //           strokeColor={record?.seniority_color}
    //           percent={record?.seniority_ratio}
    //           format={() => `${record?.seniority}`}
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Publications",
      sorter: (a, b) => a.scores.publication_count - b.scores.publication_count,
      render: (_, record, index) => {
        return (
          <div className="seniority-level" key={index}>
            <Progress
              strokeColor={record?.publication_color}
              percent={record?.publication_ratio}
              format={() => `${record?.scores.publication_count}`}
            />
          </div>
        );
      },
    },
    {
      title: "Citations",
      sorter: (a, b) => a.scores.citation_count - b.scores.citation_count,
      render: (_, record, index) => {
        return (
          <div className="seniority-level" key={index}>
            <Progress
              style={{ width: "150px" }}
              strokeColor={record?.citation_color}
              percent={record?.citation_ratio}
              format={() => `${record?.scores.citation_count}`}
            />
          </div>
        );
      },
    },
    {
      title: "H-index",
      sorter: (a, b) => a.scores["h-index"] - b.scores["h-index"],
      render: (_, record, index) => {
        return (
          <div className="seniority-level" key={index}>
            <Progress
              strokeColor={record?.h_index_color}
              percent={record?.h_index_ratio}
              format={() => `${record?.scores["h-index"]}`}
            />
          </div>
        );
      },
    },
  ];
  return (
    <div className="table">
      <Table
        columns={columnsFaculty}
        dataSource={data}
        pagination={{
          pageSize: 10,
        }}
        // scroll={{
        //   y: "65vh",
        // }}
      />
    </div>
  );
};

export default RankTableFaculty;
